<template>
  <div v-show="isShowPageLoading" class="page-loading-bar" :style="percentStyle"></div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { usePageLoading } from './usePageLoading'
import { useRouter } from 'vue-router'

const router = useRouter()
const { isShowPageLoading, percent } = usePageLoading(router)

const percentStyle = computed(() => ({
  transform: 'translate3d(' + (percent.value - 100) + '%, 0, 0)',
}))
</script>

<style lang="scss" scoped>
.page-loading-bar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  z-index: 999;
  background-color: var(--primary-color);
  transition: transform 0.3s;
  box-shadow: 0 0 3px rgba(51, 51, 51, 0.3);
  &:after {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    width: 100px;
    height: 100%;
    box-shadow: 0 0 10px var(--primary-color), 0 0 5px var(--primary-color);
    transform: rotate(3deg) translate3d(0, -4px, 0);
  }
}
</style>
